/**
 * The phone's API client: the shared transport wired to this app's token
 * storage.
 *
 * Everything interesting — auth headers, the spec §4 push headers,
 * refresh-on-401 shared across a drain — lives in `@kapture/api-client`.
 * What's app-specific is where the tokens live: the phone keeps the refresh
 * token in IndexedDB so a week offline still drains on reconnect.
 */
import { createApiClient } from '@kapture/api-client';
import { API_BASE } from './base';
import { getAccessToken, loadRefreshToken, refresh as refreshTokens, setTokens } from '@kapture/client-core';

export { ApiError, NetworkError } from '@kapture/api-client';
export type { RequestOptions } from '@kapture/api-client';

export const api = createApiClient({
  baseUrl: API_BASE,
  tokens: {
    getAccessToken,
    async refresh() {
      const refreshToken = await loadRefreshToken();
      if (!refreshToken) return false;
      try {
        const result = await refreshTokens(refreshToken);
        await setTokens({
          accessToken: result.accessToken,
          refreshToken: result.refreshToken,
          accessExpiresIn: result.accessExpiresIn,
        });
        return true;
      } catch {
        return false;
      }
    },
  },
});
